import React from 'react';
import type { NumberLineLabels } from '../../../../constants';
import { toPercent, roundTick } from '../../../utils/number-line.utils';

export interface AxisLabelsProps {
  majorTicks: number[];
  min: number;
  max: number;
  labelVisibility: NumberLineLabels | undefined;
  inputTickSet: Set<number>;
}

const isLabelVisible = (
  tick: number,
  min: number,
  max: number,
  labelVisibility: NumberLineLabels | undefined,
): boolean => {
  switch (labelVisibility) {
    case 'none':     return false;
    case 'min-only': return tick === roundTick(min);
    case 'max-only': return tick === roundTick(max);
    case 'extremes': return tick === roundTick(min) || tick === roundTick(max);
    default:         return true; // 'all' or undefined
  }
};

/** Tick label row rendered below the axis. Hides labels occupied by input widgets. */
export const AxisLabels: React.FC<AxisLabelsProps> = ({
  majorTicks, min, max, labelVisibility, inputTickSet,
}) => (
  <div className="number-line-labels-row" aria-hidden="true">
    {majorTicks.map(tick => {
      const visible = !inputTickSet.has(tick) && isLabelVisible(tick, min, max, labelVisibility);
      return (
        <span
          key={`lbl-${tick}`}
          className="number-line-tick-label"
          style={{
            left:       `${toPercent(tick, min, max)}%`,
            visibility: visible ? 'visible' : 'hidden',
          }}
        >
          {tick}
        </span>
      );
    })}
  </div>
);
